import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import { PubSub } from 'aws-amplify';
import awsConfig from "common/configs/awsConfig";
import AWS from 'aws-sdk';
import { makeId } from 'common/utils/Helpers';
import { cmdReplyTopic } from './Topics';
import elcos from 'common/apis/ElcosAPI';
import { getAuthenticationHeaders } from 'common/apis/APIUtility';


const MqttService = {
  initProvider: async (session) => {
    PubSub.removePluggable("AWSIoTProvider");
    const iotPluggable = new AWSIoTProvider(awsConfig.IoTCore);
    PubSub.addPluggable(iotPluggable);
    console.log("IoT Core provider plugged in");

    // Create and attach policy to connect to IoT Core
    AWS.config.region = awsConfig.Amplify.Auth.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: awsConfig.Amplify.Auth.identityPoolId,
      Logins: { [`cognito-idp.${awsConfig.Amplify.Auth.region}.amazonaws.com/${awsConfig.Amplify.Auth.userPoolId}`]: session.getIdToken().getJwtToken() }
    });

    const config = await getAuthenticationHeaders();

    const resp = await elcos.post(`/users/${session.idToken.payload['cognito:username']}/login`, {}, config);

    console.log("Policy attached successfully")

    return resp.data;
  },
  closeProvider: () => {
    PubSub.removePluggable("AWSIoTProvider");
    console.log("IoT Core provider removed");
  },
  subscribe: (topic, onMessage, onError, onComplete, onClose) => {
    if (!onComplete) onComplete = () => console.log("Complete");
    if (!onClose) onClose = () => console.log("Close");
    console.log(topic)
    const subscription = PubSub.subscribe(topic).subscribe({
      next: onMessage,
      error: onError,
      complete: onComplete,
      close: onClose
    });
    return subscription;
  },
  unsubscribe: (subscription) => {
    subscription.unsubscribe();
  },
  publish: async (topic, message) => {
    await PubSub.publish(topic, message);
  },
  cmdRequest: async (options) => {
    if (!options.type || !options.gatewayId || !options.resource) {
      return null;
    }

    const config = await getAuthenticationHeaders();

    return await new Promise(async (resolve, reject) => {
      let value = null;
      let sub = null;
      let timer = null;
    
      const onNext = (msg) => {
        console.log("Response Received");
        console.log(msg);
        const payload = msg.value;

        if (timer) {
          clearTimeout(timer);
        }
        if (sub) {
          sub.unsubscribe();
        }
        if (payload.status === 200) {
          value = payload.metrics ? payload.metrics : "";
        } else {
          if (payload.status) {
            reject(`Request rejected with status ${payload.status}`);
          } else {
            reject("Request rejected for invalid response");
          }
        }
        resolve(value);
      };

      const sessionId = makeId(16);
      const appId = `app-web-${makeId(4)}`;

      const manufacturer = options.manufacturer || "+";
      sub = PubSub.subscribe(cmdReplyTopic(options.gatewayId, sessionId, manufacturer)).subscribe({
        next: onNext
      });
      
      let payload = {
        "ts": new Date().getTime(), 
        "req-cid": appId,
        "sid": sessionId
      }
      if (options.body) {
        payload = {...payload, body: options.body};
      }
      if (options.metrics) {
        payload = {...payload, metrics: options.metrics};
      }

      const requestBody = { type: options.type, payload, resource: options.resource }
      await elcos.post(`/gateways/${options.gatewayId}/command`, requestBody, config);
      await new Promise(r => { timer = setTimeout(r, 10000) });

      sub.unsubscribe();

      console.log("Response not received, timeout");
      console.log(value);
      reject(value);
    });

  },
  dataRequest: async (options) => {

    if (!options.deviceId || !options.gatewayId || !options.data?.length) {
      return null;
    }

    const config = await getAuthenticationHeaders();

    return await new Promise(async resolve => {
      let value = null;
      let sub = null;
      let timer = null;
    
      const onNext = (msg) => {
        console.log("Response Received");
        console.log(msg);
        const payload = msg.value;

        if (payload.status === 200) {
          if (timer) {
            clearTimeout(timer);
          }
          const responseData = {};
          payload.metrics.map(e => {
            responseData[e.name] = e.value;
          })
          value = responseData;
        }

        if (sub) {
          sub.unsubscribe();
        }
        resolve(value);
      };

      const sessionId = makeId(16);
      const appId = `app-web-${makeId(4)}`;

      const manufacturer = options.manufacturer || "+"
      sub = PubSub.subscribe(cmdReplyTopic(options.gatewayId, sessionId, manufacturer)).subscribe({
        next: onNext
      });
      
      const payload = {
        "ts": new Date().getTime(), 
        "req-cid": appId,
        "sid": sessionId,
        "metrics": options.data
      }

      const requestBody = { type: "GET", payload, resource: `${options.deviceId}/data` }
      await elcos.post(`/gateways/${options.gatewayId}/command`, requestBody, config);
      await new Promise(r => { timer = setTimeout(r, 5000) });

      sub.unsubscribe();

      console.log("Response not received, timeout");
      console.log(value);
      resolve(value);
    });
  }
};

export default MqttService;
